import React from 'react'

const PercentageIcon = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.6096 0.217018C21.1481 0.595685 21.2777 1.33923 20.899 1.87778L5.70048 23.4935C5.32181 24.032 4.57826 24.1616 4.03971 23.783C3.50116 23.4043 3.37155 22.6608 3.75022 22.1222L18.9488 0.506508C19.3275 -0.0320399 20.071 -0.161649 20.6096 0.217018Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 4.79467C1 2.08763 3.29545 0 5.99169 0C8.68792 0 10.9834 2.08763 10.9834 4.79467C10.9834 7.5017 8.68792 9.58933 5.99169 9.58933C3.29545 9.58933 1 7.5017 1 4.79467ZM5.99169 2.38409C4.49095 2.38409 3.38409 3.52235 3.38409 4.79467C3.38409 6.06699 4.49095 7.20524 5.99169 7.20524C7.49243 7.20524 8.59929 6.06699 8.59929 4.79467C8.59929 3.52235 7.49243 2.38409 5.99169 2.38409Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.6655 19.2053C13.6655 16.4983 15.961 14.4106 18.6572 14.4106C21.3534 14.4106 23.6489 16.4983 23.6489 19.2053C23.6489 21.9123 21.3534 23.9999 18.6572 23.9999C15.961 23.9999 13.6655 21.9123 13.6655 19.2053ZM18.6572 16.7947C17.1565 16.7947 16.0496 17.933 16.0496 19.2053C16.0496 20.4776 17.1565 21.6158 18.6572 21.6158C20.1579 21.6158 21.2648 20.4776 21.2648 19.2053C21.2648 17.933 20.158 16.7947 18.6572 16.7947Z"
        />
      </g>
    </svg>
  )
}

export default PercentageIcon
